var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timelnie-main-container"},[_c('annual-index',{attrs:{"annual-list":_vm.timelineData}}),_c('div',{staticClass:"extro-intro"},[_vm._v(" "+_vm._s(_vm.currentYearTimelineData.extraInfo)+" ")]),_c('fragments-holder',{attrs:{"fragments":_vm.currentYearTimelineData.fragments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }